module.exports = __webpack_public_path__ + "media/images/pattern4-e584bfad5c785c865e7d0594597f472d.png";